<template>
  <div class="buttons is-right no-wrap">
    <b-tooltip
      label="Visualizar Motivo Recusa"
      type="is-light"
      v-if="viewMotivoRecusa"
    >
      <button
        class="button is-small is-info"
        @click="$emit('viewMotivoRecusa', viewMotivoRecusa)"
      >
        <b-icon icon="information" size="is-small" />
      </button>
    </b-tooltip>

    <b-tooltip
      label="Aprovar"
      type="is-light"
      v-if="toApprove && hasPermission"
    >
      <button
        class="button is-small is-success"
        @click="$emit('approve', item.id)"
      >
        <b-icon icon="thumb-up" size="is-small" />
      </button>
    </b-tooltip>

    <b-tooltip label="Recusar" type="is-light" v-if="toRefuse && hasPermission">
      <button
        class="button is-small is-warning"
        @click="$emit('refuse', item.id)"
      >
        <b-icon icon="thumb-down" size="is-small" />
      </button>
    </b-tooltip>

    <b-tooltip label="Editar" type="is-light">
      <router-link class="button is-small is-info" :to="toConfig">
        <b-icon icon="pencil" size="is-small" />
      </router-link>
    </b-tooltip>

    <template>
      <b-tooltip v-if="showDelete" label="Inativar" type="is-light">
        <button
          class="button is-small is-danger"
          @click="$emit('delete', item)"
        >
          <b-icon icon="checkbox-blank-off" size="is-small" />
        </button>
      </b-tooltip>
    </template>
  </div>
</template>

<script>
import Util from "@/services/Util";

export default {
  name: "ActionButtons",
  props: {
    item: {
      type: Object,
      required: true,
    },
    toConfig: {
      type: Object,
      required: true,
    },
    toApprove: {
      type: Boolean,
      default: false,
    },
    toRefuse: {
      type: Boolean,
      default: false,
    },
    viewMotivoRecusa: {
      type: String,
      default: null,
    },
    showDelete: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    hasPermission() {
      return Util.isAdmin();
    },
  },
};
</script>
